/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { darken } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useComponentStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
    backgroundColor: '#ffffff',
    alignItems: 'flex-start',
  },
  loginItem: {
    padding: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '110px',
  },
  loginSignup: {
    alignItems: 'center',
    display: 'flex',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  loginHeadingSecondary: {
    color: theme.palette.text.primary,
    marginBottom: '0',
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  loginHeadingLink: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.tertiary.main,
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    cursor: 'pointer',
    border: 0,
    background: 'none',
    marginLeft: '3px',
    padding: 0,
    '&:hover': {
      color: darken(theme.palette.tertiary.main, 0.2),
      backgroundColor: 'transparent',
    },
  },
  loginBody: {
    padding: '1rem 1.5rem',
    width: '100%',
    display: 'flex',
    boxAlign: 'center',
    height: 'calc(100vh - 110px)',
  },
  loginWrapper: {
    paddingLeft: '0',
    width: '100%',
    display: 'flex',
    boxPack: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    paddingBottom: '70px',
  },
  loginContainer: {
    maxWidth: '500px',
    width: '100%',
  },
  divider: {
    position: 'relative',
    '&:before': {
      position: 'absolute',
      content: '""',
      display: 'block',
      height: '45%',
      right: '1px',
      top: '28%',
      borderRight: '1px solid #EEEEEE',
    },
  },
}));

export { useComponentStyles };
